/* eslint-disable @stylistic/jsx-indent */

import { HTMLProps, SVGAttributes } from 'react'

import { cn } from '../libs/tailwindMerge'

interface AvatarProps extends HTMLProps<HTMLDivElement> {
  imageUrl?: string
  svgClass?: SVGAttributes<SVGSVGElement>['className']
}

export function Avatar({ imageUrl, className, svgClass }: AvatarProps) {
  return (
    <div className={cn(
      'relative overflow-hidden bg-gray-300 rounded-full',
      className,
    )}
    >
      {!imageUrl
        ? <svg
            className={cn(
              'absolute text-gray-400 top-2',
              svgClass,
            )} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
          >
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
          </svg>
        : <img src={imageUrl} />}
    </div>
  )
}
